import { TextField, styled, Typography } from '@mui/material';
import { StyledLabel } from 'src/utils/styledComponents';

const StyledTextField = styled(TextField)(({ componentType, error }) => ({
  background: '#fff',
  borderRadius: '0.3125rem',
  '& .MuiOutlinedInput-root': {
    borderRadius: '0.3125rem',
    fontFamily: 'Montserrat',
    ...(componentType === 'secondary' && {
      height: '3.5rem',
      gap: '0.625rem',
      padding: '1rem'
    }),
    '& fieldset': {
      borderColor: '#f0f0f0'
    },
    '&:hover fieldset': {
      borderColor: '#88F231'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#88F231'
    },
    '& input': {
      padding: '8px 14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: 'text.primary'
    }
  },
  '& .MuiFormHelperText-root': {
    color: '#e74c3c',
    margin: '2px',
    minHeight: error ? '20px' : '0'
  }
}));

const CustomTextField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled = false,
  placeholder,
  showError = false,
  helperMessage,
  componentType,
  ...props
}) => {
  const shouldShowError = showError && error && touched;

  if (componentType === 'secondary') {
    return (
      <div key={name} id={`${name}-container`} style={{ width: '100%' }}>
        {label && (
          <StyledLabel
            variant="body2"
            gutterBottom
            component="label"
            htmlFor={name}
          >
            {label}
          </StyledLabel>
        )}
        <StyledTextField
          key={`${name}-input`}
          fullWidth
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          error={shouldShowError}
          size="small"
          componentType={componentType}
          sx={{
            '& .MuiOutlinedInput-root input': {
              ...(componentType === 'secondary' && {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              })
            }
          }}
          {...props}
        />
        {helperMessage && !shouldShowError && (
          <Typography variant="caption" color="textSecondary">
            {helperMessage}
          </Typography>
        )}
        {shouldShowError && (
          <Typography variant="caption" color="error">
            {error}
          </Typography>
        )}
      </div>
    );
  }

  return (
    <StyledTextField
      key={name}
      fullWidth
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      disabled={disabled}
      error={shouldShowError}
      helperText={shouldShowError ? error : ''}
      size="small"
      componentType={componentType}
      {...props}
    />
  );
};

export default CustomTextField;
